"use strict";

exports.__esModule = true;
exports.isOfflinePostPageMigrationEnabled = exports.isPostEditorDeprecated = exports.isExperimentEnabled = exports.getExperiments = void 0;

var _communitiesBlogExperiments = require("@wix/communities-blog-experiments");

var _isExperimentEnabled = _interopRequireDefault(require("../services/is-experiment-enabled"));

var _searchParamsSelectors = require("./search-params-selectors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var getExperiments = function getExperiments(state) {
  return state.experiments;
};

exports.getExperiments = getExperiments;

var isExperimentEnabled = function isExperimentEnabled(state, name, value) {
  return (0, _isExperimentEnabled["default"])(getExperiments(state), name, value);
};

exports.isExperimentEnabled = isExperimentEnabled;

var isPostEditorDeprecated = function isPostEditorDeprecated(state) {
  return isExperimentEnabled(state, _communitiesBlogExperiments.EXPERIMENT_DEPRECATE_MOBILE_POST_EDITOR) && (0, _searchParamsSelectors.getIsMobile)(state) && !(0, _searchParamsSelectors.isOneApp)(state);
};

exports.isPostEditorDeprecated = isPostEditorDeprecated;

var isOfflinePostPageMigrationEnabled = function isOfflinePostPageMigrationEnabled(state) {
  return isExperimentEnabled(state, _communitiesBlogExperiments.EXPERIMENT_OFFLINE_POST_PAGE_MIGRATION);
};

exports.isOfflinePostPageMigrationEnabled = isOfflinePostPageMigrationEnabled;